import React, { useState, useEffect } from 'react';

const AwardsSection = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  const awards = [
    { year: '2023', title: 'Most Transparent Broker' },
    { year: '2023', title: 'Best Trading Experience Broker' },
    { year: '2023', title: 'Most Trusted Financial Broker LatAm' },
    { year: '2023', title: 'Best Online Trading Platform MENA' },
    { year: '2021', title: 'Best Mobile Trading Platform' },
    { year: '2021', title: 'Best Investment Broker' },
    { year: '2020', title: 'Best Trading Platform' },
    { year: '2020', title: 'Best Customer Support Broker' },
    { year: '2019', title: 'Best Mobile Trading Experience' },
    { year: '2019', title: 'Best Customer Support Broker' },
    { year: '2018', title: 'Best Trading Platform' },
    { year: '2017', title: 'Innovative Broker' },
  ];

  const [isVisible, setIsVisible] = useState(false);

  // Auto scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      setScrollPosition((prev) => (prev + 1) % awards.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [awards.length]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="section-premium">
      {/* Premium Background with image overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-yellow-900/20 to-black"></div>
        <div className="absolute inset-0 opacity-30" style={{
          background: 'radial-gradient(circle at 50% 50%, rgba(234, 179, 8, 0.1) 0%, transparent 70%)'
        }}></div>
      </div>

      <div className={`relative z-10 max-w-7xl mx-auto px-4 md:px-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Title */}
        <div className="text-center mb-12 md:mb-20 animate-scale-in">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
            <span className="gradient-gold-text" style={{ fontFamily: "'Playfair Display', serif" }}>7 years</span> of excellence
          </h2>
        </div>

        {/* Awards Carousel */}
        <div className="relative overflow-hidden animate-fade-in-up animate-delay-200 -mx-4 md:mx-0">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${scrollPosition * 100}%)`,
            }}
          >
            {[...awards, ...awards].map((award, index) => (
              <div
                key={index}
                className="w-full flex-shrink-0 px-4 md:px-0"
              >
                <div className="premium-card h-56 md:h-64 flex flex-col justify-center items-center text-center group mx-auto max-w-md">
                  <div className="gradient-gold-text text-5xl md:text-6xl lg:text-7xl font-bold mb-4 md:mb-6 animate-float" style={{ fontFamily: "'Playfair Display', serif" }}>{award.year}</div>
                  <div className="text-white text-lg md:text-xl lg:text-2xl font-semibold leading-relaxed px-6">{award.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Manual Navigation Dots */}
        <div className="flex items-center justify-center space-x-2 mt-8 md:mt-12 animate-fade-in-up animate-delay-400">
          {awards.slice(0, Math.min(awards.length, 8)).map((_, index) => (
            <button
              key={index}
              onClick={() => setScrollPosition(index)}
              className={`h-2 rounded-full transition-all duration-300 hover-scale ${
                index === scrollPosition % awards.length ? 'bg-yellow-500 w-8 animate-glow' : 'bg-gray-600 w-2'
              }`}
              aria-label={`Go to award ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
